import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const PracticesPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar/>
        <div className="container">Practices Roles content </div>
        
        </div>
    )
};